export const ENV = {
	CORE_END_POINT: 'https://core-api-sypc.onrender.com/api/v1',
	REDUX_LOGGER: false,
};
